<template>
  <div id="das">
    <div class="card-wrapper" :class="card.wrapperClass" v-for="(card, index) in dataInfoCards" :key="index">
      <div class="card hoverable" :class="card.cardClass" v-if="index === currentCardIndex">
        <div class="card-content">
          <span class="card-title">{{ card.title }}</span>

          <p>{{ card.description }}</p>
          <div class="btn-action">
            <button class="btn waves-effect amber lighten-1 btn-rounded black-text"
              @click="$_handleClick(card.route, index)">
              {{ card.buttonText }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="indicators-container col s12">
      <div class="indicator" :style="{ background: currentCardIndex === indx ? '#707070' : '' }"
        v-for="(indicator, indx) in dataInfoCards" @click="currentCardIndex = indx" :key="indx"></div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"
export default {
  name: 'GettingStarted',

  props: {
    dataInfoCards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentCardIndex: 0,
    };
  },
  mounted() { },
  computed: {
    indicatorsLengthX() {
      return this.dataInfoCards.length;
    },
  },
  methods: {
    ...mapActions("Surveys", {
      updateWindHazardStarted: "SET_WIND_HAZARD_STARTED",
      updateFloodHazardStarted: "SET_FLOOD_HAZARD_STARTED",
      updateWaterHazardStarted: "SET_WATER_HAZARD_STARTED",
    }),
    $_handleClick(route, index) {
      if (route) {
        if (route === "WindHazardSurvey") this.updateWindHazardStarted(true);
        if (route === "FloodHazardSurvey") this.updateFloodHazardStarted(true);
        if (route === "WaterHazardSurvey") this.updateWaterHazardStarted(true);
        this.$router.push({ name: route });
      }

      // Show next card
      this.currentCardIndex = index + 1;
    },
  },
};
</script>
<style lang="scss" scoped>
#das {
  display: flow-root;
  max-width: 768px;
  margin: 24px auto;
  padding: 16px;

  /* .card-wrapper { */
  .card {
    position: relative;
    min-height: 65vh;
    border-radius: 5px;

    .card-content {
      padding: 24px;
      animation: fadeIn ease .5s;

      .card-title {
        font-size: 32px;
        color: #4d4d4d;
      }

      p {
        line-height: 24px;
      }

      .btn-action {
        position: absolute;
        left: 50%;
        bottom: 24px;
        transform: translate(-50%, 0);

        button {
          min-width: 140px;
        }
      }
    }

    @keyframes fadeIn {
      0% {
        opacity: 0.2;
      }

      100% {
        opacity: 1;
      }
    }
  }

  /* } */
  .indicators-container {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    text-align: center;

    .indicator {
      cursor: pointer;
      margin: 0 5px;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      border: 1px solid #707070;
    }
  }
}

.fade-enter {
  transition: opacity 0.2s;
}
</style>
